var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowcursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8437 3.7344C15.8437 1.67195 17.5157 0 19.5781 0H51.2656C53.3281 0 55 1.67195 55 3.7344V35.4219C55 37.4843 53.3281 39.1563 51.2656 39.1563C49.2031 39.1563 47.5312 37.4843 47.5312 35.4219V12.7501L6.37503 53.9062C4.91665 55.3646 2.55216 55.3646 1.09378 53.9062C-0.364594 52.4478 -0.364594 50.0833 1.09378 48.625L42.25 7.46881H19.5781C17.5157 7.46881 15.8437 5.79686 15.8437 3.7344Z",
    fill: "#FBB536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcursor);
export default __webpack_public_path__ + "static/media/arrowcursor.5cb44ac69939aab2f06f77b88ccd36cc.svg";
export { ForwardRef as ReactComponent };